import service from './request'
import uploadService from "./uploadRequest.js";
import downloadService from "./downloadRequest.js";

/**
 * 获取会话标签信息列表
 */
export const getListSessionLable = data => {
    return service({
	      showLoading: true,//调用预加载
        url: '/platform/sessionLable/cfg/getList',
        method: 'post',
        type: 'body',
        data
    })
}


/**
 * 获取会话标签信息树
 */
export const getTreeSessionLable = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/sessionLable/cfg/getTree',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取新增或修改的会话标签信息列表树
 */
 export const getAddOrModifyTree = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/sessionLable/cfg/getAddOrModifyTree',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取热点会话标签信息列表
 */
 export const getHotPointList = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/sessionLable/cfg/getHotPointList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 会话标签信息添加
 */
export const addInfoSessionLable = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sessionLable/cfg/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 会话标签信息修改
 */
 export const updateInfoSessionLable = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sessionLable/cfg/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 会话标签删除
 */
 export const delInfoSessionLable = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sessionLable/cfg/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 会话标签导出
 */
 export const expExcelSessionLable = data => {
    return downloadService({
        showLoading: true,
        url: "/platform/sessionLable/cfg/expExcel",
        method: "get",
        responseType: "blob",
        data
    });
}


/**
 * 会话标签导入
 */
export const impExcelSessionLable = data => {
    return uploadService({
        showLoading: true,
        url: "/platform/sessionLable/cfg/impExcel",
        method: "post",
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/SessionLableManagement.js